import {
  createContext,
  type FC,
  type PropsWithChildren,
  useContext,
} from 'react';
import type { NotificationInstance } from 'antd/es/notification/interface';
import { notification } from 'antd';

const NotificationContext = createContext<NotificationInstance>(null!);

export const NotificationProvider: FC<PropsWithChildren> = ({ children }) => {
  const [notifyApi, contextHolder] = notification.useNotification();

  return (
    <NotificationContext.Provider value={notifyApi}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotify = () => {
  const notifyApi = useContext(NotificationContext);

  if (!notifyApi) {
    throw new Error(
      'useNotify must be used within a NotificationProvider, did you forget to use <NotificationProvider>...</NotificationProvider>?',
    );
  }

  return notifyApi;
};
